// import * as firebase from "firebase";

import App from "./App.vue";
import Vue from "vue";
// import router from "./router";
// import store from "./store";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;

// const configOptions = {
//   apiKey: 'AIzaSyBhHTQWfKsJSMkk8Be_ajV6oAbwCy79PlU',
//   authDomain: 'onechart-prod.firebaseapp.com',
//   databaseURL: 'https://onechart-prod.firebaseio.com',
//   projectId: 'onechart-prod',
//   storageBucket: 'onechart-prod.appspot.com',
//   messagingSenderId: '530093705162'
// };

// firebase.initializeApp(configOptions);
// firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)

// firebase.auth().onAuthStateChanged(user => {
//   store.dispatch("auth/firebaseSignInReturn", user);
// })

new Vue({
  // router,
  // store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
